<template>
    <v-row>
      <v-col cols="12">
        <v-card 
        class="mx-auto"
    >
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-form
        class="m-5"
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      v-model="name"
      :counter="10"
      :rules="nameRules"
      label="Nombre completo del conductor"
      required
    ></v-text-field>

    <v-text-field
      v-model="enrollment"
      :counter="10"
      :rules="enrollmentRules"
      label="Cédula de Identidad"
      required
    ></v-text-field>


  <v-file-input accept="image/png, image/jpeg, image/bmp" v-model="images" label="Imagenes del conductor (opcional)"></v-file-input>

    

    <v-btn
      :disabled="!name||!enrollment"
      color="primary"
      class="mr-4"
      @click="subirConduc" 
      :loading="status"
    >
      Generar
    </v-btn>

    
  </v-form>
        </v-col>
      </v-row>
    </v-container>
        
    </v-card>
      </v-col>
     
      
    </v-row>
    

</template>
<script>

  import {SubirConductor} from '../../../../../../services/team/driving'

  export default {
    data: () => ({
      valid: true,
      name: '',
      images:[],

      imagess:[],
      enrollment:'',
      status:false,
      disabled:false,
      
      nameRules: [
        v => !!v || 'Nombre es requerido',
        v => (v && v.length <= 20) || 'Name must be less than 10 characters',
      ],

       rulesImages: [
        value => value || value.size > 2000000 || 'Avatar size should be less than 2 MB!',
      ],

      enrollmentRules: [
        v => !!v || 'Cédula es requerida',
        v => (v && v.length <= 20) || 'La placa esta mal estructurada',
      ],

      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      checkbox: false,
    
      item: 1,
      items: [
        { text: 'Real-Time', icon: 'mdi-clock' },
        { text: 'Audience', icon: 'mdi-account' },
        { text: 'Conversions', icon: 'mdi-flag' },
      ],
    
    
    }),

    

    watch: {
      images(item){
       return this.imagess.push(item)
      }
    },

    methods: {

      GetImg: function(event) {
            this.images = event.target.files;
      },

      vaciarcampos:function(){

        this.name = '';
        this.enrollment = '';
        this.images = '';

      },

      subirConduc:function(){
        this.$store.dispatch('LoadingFetchActions', true);
        this.status = true
        this.disabled = true

        var data = new FormData();
        data.append('name', this.name);
        data.append('enrollment', this.enrollment);
        data.append('images',  this.images);
        
        SubirConductor(data).then(response=>{
          console.log(response);
          this.status = false
          this.disabled = false
          this.$router.push({path: '/conductor'});
          this.$store.dispatch('GetDrivings');
          this.$toastr.success('Se ha agregado el nuevo conductor');
          this.$store.dispatch('LoadingFetchActions', false);
          this.vaciarcampos();
        

        }).catch(errors=>{
          console.log(errors);
         this.status = false
          this.disabled = false
          this.$toastr.error(errors);
          this.$store.dispatch('LoadingFetchActions', false);
        })



      },

      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>